/*
 * @Description: Reducer
 * @FilePath: \kitchen-online-web\src\redux\reducer.js
 * @Author: Yongchao Wang
 * @Date: 2021-07-03 17:13:29
 * @LastEditors: Yu Wang
 * @LastEditTime: 2021-08-18 15:57:26
 */
import { useReducer } from 'react';
import initialValue from './initState';

import sizeAction from './reducers/size';
import wholeAction from './reducers/whole';
import doorAction from './reducers/door';
import mesaAction from './reducers/mesa';
import storageAction from './reducers/storage';
import renderAction from './reducers/render';

const obj = {
  ...sizeAction,
  ...wholeAction,
  ...doorAction,
  ...mesaAction,
  ...storageAction,
  ...renderAction,
};

// function deepCopyByMessageChannel(target) {
//   return new Promise((resolve) => {
//     const channel = new MessageChannel();
//     channel.port2.onmessage = (ev) => resolve(ev.data);
//     channel.port1.postMessage(target);
//   }).then((data) => data);
// }

// function deepCopyByHistory(target) {
//   const prev = window.history.state;
//   window.history.replaceState(target, document.title);
//   const res = window.history.state;
//   window.history.replaceState(prev, document.title);
//   return res;
// }


function Reducer() {
  const [initState, dispatch] = useReducer((state, action) => {
    const deepState = state;
    const { type, payload } = action;
    if (type === 'json-template') {
      if (!payload.isOfferInit && localStorage.getItem('appointmentSucceeded') === 'true') {
        localStorage.setItem('appointmentSucceeded', 'false');
      }
    }

    const fn = obj[type];
    if (fn) {
      return fn(deepState, payload);
    }
    return { ...state };
  }, initialValue);
  return { initState, dispatch };
}

export default Reducer;

